export interface Referraltype {
    referenceid:string,
    referencetype:string,
    referencename:string,
    noofparticipantsmin:number,
    noofparticipantsmax:number,
    points:number,
    referencelocale:string,
    linkval: string,
    formid: string,    
  }